import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana106Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1443_5185)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M684.532 561.173L614.031 507.279L604.836 511.899L637.021 584.27L678.401 579.651C690.662 575.955 687.597 565.793 684.532 561.173Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M594.105 590.429L637.018 584.27L604.833 511.898L566.517 528.836L594.105 590.429Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M545.065 598.13L594.109 590.431L566.522 528.838L522.076 548.856L545.065 598.13Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M466.896 610.446L545.06 598.128L522.071 548.854L453.103 579.65L466.896 610.446Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M566.517 465.704L614.028 507.279L552.723 534.995L528.201 481.102C533.31 478.535 545.06 472.479 551.19 468.783C557.321 465.088 563.962 465.19 566.517 465.704Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M479.164 505.737L528.207 481.1L552.729 534.993L503.686 556.551L479.164 505.737Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M430.117 530.377L479.161 505.74L503.683 556.554L453.107 579.652L430.117 530.377Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M430.122 615.065L466.905 610.446L430.122 530.375L396.404 545.773L430.122 615.065Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M384.139 622.768L430.117 615.069L396.4 545.777L358.084 564.255L384.139 622.768Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M328.96 630.464L384.135 622.765L358.08 564.252L309.036 587.349L328.96 630.464Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M247.733 642.783L328.962 630.465L309.038 587.35L235.939 621.822C234.665 622.423 233.676 623.539 233.365 624.912C230.139 639.142 241.399 642.783 247.733 642.783Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1443_5185" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1443_5185" transform="matrix(0.00210224 0 0 0.00278702 -4.69747 -3.27321)"/>
    </pattern>
    <image id="image0_1443_5185"  width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};